import { render, staticRenderFns } from "./HowToSection.vue?vue&type=template&id=5c0a03d6&scoped=true"
import script from "./HowToSection.vue?vue&type=script&lang=js"
export * from "./HowToSection.vue?vue&type=script&lang=js"
import style0 from "./HowToSection.vue?vue&type=style&index=0&id=5c0a03d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a03d6",
  null
  
)

export default component.exports